import React from 'react';
import { ShieldCheck } from 'lucide-react';
export const PrivateLabel = () => {
  return <div className="py-20 lg:py-24 bg-white min-h-[calc(100vh-300px)]" data-id="element-881">
      <div className="max-w-content mx-auto px-5 sm:px-8 lg:px-12" data-id="element-882">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-883">
          <div className="w-20 h-20 bg-brandRed/10 rounded-full flex items-center justify-center mx-auto mb-8" data-id="element-884">
            <ShieldCheck className="w-10 h-10 text-brandRed" data-id="element-885" />
          </div>
          <h1 className="text-4xl md:text-5xl font-heading font-bold text-ink mb-6 leading-tight" data-id="element-886">
            Private-Label Production
          </h1>
          <p className="text-xl text-gray-600 leading-relaxed" data-id="element-887">
            We operate entirely behind the scenes. Our private-label production
            ensures that your brand remains front and center with your
            customers.
          </p>
        </div>

        <div className="max-w-3xl mx-auto prose prose-lg prose-red text-gray-600" data-id="element-888">
          <p data-id="element-889">
            At Tier One Apparel, we understand that your brand identity is your
            most valuable asset. That's why we offer comprehensive private-label
            production services for our wholesale partners.
          </p>
          <h3 data-id="element-890">What Private-Label Means for You</h3>
          <ul data-id="element-891">
            <li data-id="element-892">
              <strong data-id="element-893">No Tier One Branding:</strong> Our logos will never appear
              on the exterior of the garments you sell.
            </li>
            <li data-id="element-894">
              <strong data-id="element-895">Custom Inside Tags:</strong> We can print your brand's
              logo and sizing information on the inside neck tag.
            </li>
            <li data-id="element-896">
              <strong data-id="element-897">Blind Shipping:</strong> Orders can be drop-shipped
              directly to your customers with your company name on the return
              address.
            </li>
            <li data-id="element-898">
              <strong data-id="element-899">Client Protection:</strong> We never market directly to
              your end-users. Your clients remain your clients.
            </li>
          </ul>
          <p data-id="element-900">
            By leveraging our manufacturing capabilities under your own brand
            name, you can scale your business without the overhead of running a
            production facility.
          </p>
        </div>
      </div>
    </div>;
};